import { create } from 'zustand'
import { administracaoAPI } from '../../api'
import { Usuario } from '../../types/administracao/usuario'

interface UsuarioState {
  cleanUsuarioStates: () => void
  filters: FiltersUsuario
  setFilters: (filters: FiltersUsuario | ((prev: FiltersUsuario) => FiltersUsuario)) => void
  isFiltered: () => boolean
  cleanFilters: () => void
  usuarios: Usuario[]
  setUsuarios: (filters: FiltersUsuario) => Promise<void>
  loadingUsuarios: boolean,
  setLoadingUsuarios: (loading: boolean) => void
  erroUsuarios: boolean,
  setErroUsuarios: (erro: boolean) => void
  messageErroUsuarios: string
  totalPages: number
  totalItems: number

  //USUARIO REGISTER
  selectedUsuarioId: number
  setSelectedUsuarioId: (id: number) => void
}

export interface FiltersUsuario {
  pesquisarNome: string
  pesquisarEmail: string
  pesquisarLogin: string
  status: number
  page: number
  pageSize: number
}

export const useUsuarioStore = create<UsuarioState>((set, get) => ({
  usuarios: [],
  setUsuarios: async (filters: FiltersUsuario) => {
    set(() => ({ loadingUsuarios: true, erroUsuarios: false }))
    const result = await administracaoAPI.getUsuario(filters)
    if (result.statusCode == 200 && result.data) {
      set(() => ({
        usuarios: result.data?.items ?? [], filters: { ...filters, page: result.data?.currentPage ?? 1, pageSize: result.data?.pageSize ?? 25 }, totalPages: result.data?.totalPages ?? 0, totalItems: result.data?.totalItems ?? 0
      }))
    }
    else {
      set(() => ({ erroUsuarios: true, messageErroUsuarios: result.error?.Message ?? "Ocorreu um erro inesperado." }))
    }
    set(() => ({ loadingUsuarios: false }))
  },
  totalPages: 0,
  totalItems: 0,
  loadingUsuarios: false,
  setLoadingUsuarios: (loading: boolean) => {
    set(() => ({ loadingUsuarios: loading }))
  },
  erroUsuarios: false,
  setErroUsuarios: (erro: boolean) => {
    set(() => ({ erroUsuarios: erro }))
  },
  messageErroUsuarios: "",

  filters: { pesquisarNome: "", pesquisarEmail: "", pesquisarLogin: "", status: 1, page: 1, pageSize: 25 },
  setFilters: (filters) => {
    set((state) => ({
      filters: typeof filters === 'function' ? filters(state.filters) : filters,
    }))
  },
  isFiltered: () => {
    const { filters } = get()
    if (filters.pesquisarNome != "" || filters.pesquisarEmail != "" || filters.pesquisarLogin != "" || filters.status != 1) {
      return true
    }
    return false
  },
  cleanFilters: () => {
    set(() => {
      const { setUsuarios } = get()
      const cleanedFilters: FiltersUsuario = { pesquisarNome: "", pesquisarEmail: "", pesquisarLogin: "", status: 1, page: 1, pageSize: 25 }
      setUsuarios(cleanedFilters)
      return ({
        filters: cleanedFilters
      })
    })
  },
  cleanUsuarioStates: () => {
    set(() => ({ usuarios: [], totalPages: 0, totalItems: 0, loadingUsuarios: false, erroUsuarios: false, messageErroUsuarios: "", filters: { pesquisarNome: "", pesquisarEmail: "", pesquisarLogin: "", status: 1, page: 1, pageSize: 25 }, selectedUsuarioId: 0 }))
  },

  //CARGOS REGISTER
  selectedUsuarioId: 0,
  setSelectedUsuarioId: (id: number) => {
    set(() => ({ selectedUsuarioId: id }))
  },
}))